export default {
  pupularService: 'บริการยอดนิยม',
  newsAndUpdates: 'ข่าวสารและโปรโมชั่น',
  servisheroApp: 'แอปพลิเคชันเซอร์วิสฮีโร่',
  downloadSHApp: 'ดาวน์โหลดแอปเพื่อประสบการณ์ที่ดีกว่า ในการจองบริการ ติดตามสถานะงาน และเช็คโปรโมชั่น'
}